import axios from 'axios';
import * as types from './actionTypes';
import { handleError } from '../errors/handleError';
import i18n from '../i18n';
import { addAlert } from './alertActions';
import { checkProjectConfig } from './projectConfigActions';
import { getProjectVersionMenuItems } from './menuItemActions';

export function errorHandler(dispatch, error, type) {
    const errorMessage = handleError(error);

    dispatch({
        type,
        error: errorMessage,
    });
}

export function getPagesforDropdown(projectId) {
    const token = window.genesisToken();
    return function (dispatch) {
        dispatch({
            type: types.GET_PROJECT_PAGES_DROPDOWN_PENDING,
        });
        return axios.get(`${window.GENESIS_CMS_API_URL}/v3/pages/${projectId}/latest?includeModules=true&token=${token}&sessionId=${localStorage.getItem('SessionId')}`)
            .then((response) => {
                dispatch({
                    type: types.GET_PROJECT_PAGES_DROPDOWN_SUCCESS,
                    payload: response.data,
                });
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.GET_PROJECT_PAGES_DROPDOWN_FAILED);
            });
    };
}

export function getPagesforProject(projectId, skipDropdown = false) {
    const token = window.genesisToken();
    return function (dispatch) {
        dispatch({
            type: types.GET_PROJECT_PAGES_PENDING,
        });
        return axios.get(`${window.GENESIS_CMS_API_URL}/v3/pages/${projectId}/latest?token=${token}&sessionId=${localStorage.getItem('SessionId')}`)
            .then((response) => {
                if (skipDropdown === false) dispatch(getPagesforDropdown(projectId));
                dispatch({
                    type: types.GET_PROJECT_PAGES_SUCCESS,
                    payload: response.data,
                });
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.GET_PROJECT_PAGES_FAILED);
            });
    };
}

export function addContentSectionToPage(pageId, projectId) {
    const token = window.genesisToken();
    return function (dispatch) {
        dispatch({
            type: types.ADD_CONTENT_SECTION_PENDING,
        });
        return axios({
            url: `${window.GENESIS_CMS_API_URL}/v3/sections?token=${token}&sessionId=${localStorage.getItem('SessionId')}`,
            headers: {
                'Content-Type': 'application/json',
            },
            data: { pageId },
            method: 'POST',
        })
            .then((response) => {
                dispatch({
                    type: types.ADD_CONTENT_SECTION_SUCCESS,
                    payload: response.data.data,
                });
                dispatch(getPagesforProject(projectId));
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.ADD_CONTENT_SECTION_FAILED);
            });
    };
}

export function reorderPageSections(pageId, projectId, sections) {
    const token = window.genesisToken();
    return function (dispatch) {
        dispatch({
            type: types.REORDER_SECTIONS_PENDING,
        });
        return axios({
            url: `${window.GENESIS_CMS_API_URL}/v3/pages/${pageId}/reorder?token=${token}&sessionId=${localStorage.getItem('SessionId')}`,
            headers: {
                'Content-Type': 'application/json',
            },
            data: { id: pageId, contentSections: sections },
            method: 'POST',
        })
            .then((response) => {
                dispatch({
                    type: types.REORDER_SECTIONS_SUCCESS,
                    payload: response.data.data,
                });
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.REORDER_SECTIONS_FAILED);
            });
    };
}

export function deleteContentSection(sectionId, projectId) {
    const token = window.genesisToken();
    return function (dispatch) {
        dispatch({
            type: types.DELETE_CONTENT_SECTION_PENDING,
        });
        return axios.delete(`${window.GENESIS_CMS_API_URL}/v3/sections/${sectionId}?token=${token}&sessionId=${localStorage.getItem('SessionId')}`)
            .then((response) => {
                dispatch({
                    type: types.DELETE_CONTENT_SECTION_SUCCESS,
                    payload: response.data,
                });
                dispatch(addAlert({
                    message: i18n.t('content.delete-content-section'),
                    global: true,
                    type: 'info',
                    id: `delete-content-section-${sectionId}`,
                    dismissable: true,
                }));
                dispatch(getPagesforProject(projectId));
                dispatch(checkProjectConfig(projectId));
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.DELETE_CONTENT_SECTION_FAILED);
            });
    };
}

export function updateContentSection(section, projectId) {
    const token = window.genesisToken();
    return function (dispatch) {
        dispatch({
            type: types.UPDATE_CONTENT_SECTION_PENDING,
        });
        return axios.put(`${window.GENESIS_CMS_API_URL}/v3/sections/?token=${token}&sessionId=${localStorage.getItem('SessionId')}`, section)
            .then((response) => {
                dispatch({
                    type: types.UPDATE_CONTENT_SECTION_SUCCESS,
                    payload: response.data,
                });
                dispatch(getPagesforProject(projectId));
                dispatch(checkProjectConfig(projectId));
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.UPDATE_CONTENT_SECTION_FAILED);
            });
    };
}

export function addContentToSection(contentObject, projectId) {
    const token = window.genesisToken();
    return function (dispatch) {
        dispatch({
            type: types.ADD_CONTENT_PENDING,
        });
        return axios({
            url: `${window.GENESIS_CMS_API_URL}/v3/content?token=${token}&sessionId=${localStorage.getItem('SessionId')}`,
            headers: {
                'Content-Type': 'application/json',
            },
            data: contentObject,
            method: 'POST',
        })
            .then((response) => {
                dispatch({
                    type: types.ADD_CONTENT_SUCCESS,
                    payload: response.data.data,
                });
                dispatch(checkProjectConfig(projectId));
                if (contentObject.tapType && contentObject.tapType === 5) {
                    dispatch(addAlert({
                        message: i18n.t('content.page-added'),
                        global: true,
                        type: 'success',
                        id: `page-added-${response.data.data.id}`,
                        dismissable: true,
                    }));
                }
                dispatch(getPagesforProject(projectId));
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.ADD_CONTENT_FAILED);
            });
    };
}

export function updateContent(contentObject, projectId) {
    const token = window.genesisToken();
    return function (dispatch) {
        dispatch({
            type: types.UPDATE_CONTENT_PENDING,
        });
        return axios.put(`${window.GENESIS_CMS_API_URL}/v3/content/?token=${token}&sessionId=${localStorage.getItem('SessionId')}`, contentObject)
            .then((response) => {
                dispatch({
                    type: types.UPDATE_CONTENT_SUCCESS,
                    payload: response.data,
                });
                dispatch(checkProjectConfig(projectId));
                if (contentObject.tapType && contentObject.tapType === 5) {
                    dispatch(addAlert({
                        message: i18n.t('content.page-added'),
                        global: true,
                        type: 'success',
                        id: `page-added-${response.data.data.id}`,
                        dismissable: true,
                    }));
                }
                dispatch(getPagesforProject(projectId));
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.UPDATE_CONTENT_FAILED);
            });
    };
}

export function deleteContent(contentId, projectId) {
    const token = window.genesisToken();
    return function (dispatch) {
        dispatch({
            type: types.DELETE_CONTENT_PENDING,
        });
        return axios.delete(`${window.GENESIS_CMS_API_URL}/v3/content/${contentId}?token=${token}&sessionId=${localStorage.getItem('SessionId')}`)
            .then((response) => {
                dispatch({
                    type: types.DELETE_CONTENT_SUCCESS,
                    payload: response.data,
                });
                dispatch(getPagesforProject(projectId));
                dispatch(checkProjectConfig(projectId));
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.DELETE_CONTENT_FAILED);
            });
    };
}

export function deletePage(pageId, pageName, projectId) {
    const token = window.genesisToken();
    return function (dispatch) {
        dispatch({
            type: types.DELETE_PAGE_PENDING,
        });
        return axios.delete(`${window.GENESIS_CMS_API_URL}/v3/pages/${pageId}?token=${token}&sessionId=${localStorage.getItem('SessionId')}`)
            .then((response) => {
                dispatch({
                    type: types.DELETE_PAGE_SUCCESS,
                    payload: response.data,
                });
                dispatch(checkProjectConfig(projectId));
                dispatch(addAlert({
                    message: `'${pageName}' ${i18n.t('hasBeenDeleted')}`,
                    // view: '/pages/pages',
                    global: true,
                    type: 'info',
                    id: `delete-page-success-${pageId}`,
                    dismissable: true,
                }));
                dispatch(getPagesforProject(projectId));
                dispatch(getProjectVersionMenuItems(projectId));
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.DELETE_PAGE_FAILED);
            });
    };
}

export function addPage(page, projectId, icon, showAlert = false) {
    const token = window.genesisToken();
    page.icon = icon;
    return function (dispatch) {
        dispatch({
            type: types.ADD_PAGE_PENDING,
        });
        return axios({
            url: `${window.GENESIS_CMS_API_URL}/v3/pages?token=${token}&sessionId=${localStorage.getItem('SessionId')}`,
            headers: {
                'Content-Type': 'application/json',
            },
            data: page,
            method: 'POST',
        })
            .then((response) => {
                dispatch({
                    type: types.ADD_PAGE_SUCCESS,
                    payload: response.data.data,
                });
                if (icon !== null) {
                    dispatch(getProjectVersionMenuItems(projectId));
                }
                if (showAlert === true) {
                    dispatch(addAlert({
                        message: i18n.t('content.page-added'),
                        global: true,
                        type: 'success',
                        id: `page-added-${response.data.data.id}`,
                        dismissable: true,
                    }));
                } else if (response.data.data.menuItemAdded) {
                    dispatch(addAlert({
                        message: `'${response.data.data.name.length > 12 ? response.data.data.name.substring(0, 12) : response.data.data.name}' ${i18n.t('content.page-added-with-menu')}`,
                        global: true,
                        type: 'success',
                        id: `page-added-with-menu-${response.data.data.id}`,
                        dismissable: true,
                    }));
                }
                dispatch(getPagesforProject(projectId));
                dispatch(checkProjectConfig(projectId));
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.ADD_PAGE_FAILED);
            });
    };
}

export function updatePage(page, projectId) {
    const token = window.genesisToken();
    return function (dispatch) {
        dispatch({
            type: types.UPDATE_PAGE_PENDING,
        });
        return axios.put(`${window.GENESIS_CMS_API_URL}/v3/pages/?token=${token}&sessionId=${localStorage.getItem('SessionId')}`, page)
            .then((response) => {
                dispatch({
                    type: types.UPDATE_PAGE_SUCCESS,
                    payload: response.data,
                });
                if (response.data.data.menuItemRemoved) {
                    dispatch(addAlert({
                        message: `'${page.name}' ${i18n.t('content.page-edited-with-removed-menu')}`,
                        global: true,
                        type: 'success',
                        id: `page-edit-menu-${response.data.data.id}`,
                        dismissable: true,
                    }));
                } else if (response.data.data.menuItemAdded) {
                    dispatch(addAlert({
                        message: `'${page.name}' ${i18n.t('content.page-added-with-menu')}`,
                        global: true,
                        type: 'success',
                        id: `page-edit-without-menu-${response.data.data.id}`,
                        dismissable: true,
                    }));
                }
                dispatch(getPagesforProject(projectId));
                dispatch(checkProjectConfig(projectId));
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.UPDATE_PAGE_FAILED);
            });
    };
}
